import gql from "graphql-tag"

export default gql`
  query ColleaguesReportQuery($from: Date!, $to: Date!) {
    colleaguesExport(from: $from, to: $to) {
      zipName
      zipFile
    }
  }
`
